var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalVideosIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 69,
    viewBox: "0 0 68 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 68,
    height: 68,
    rx: 34,
    fill: "#FFF4F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9914 27.8125H29.0086C23.9464 27.8125 21.4152 27.8125 19.9935 29.2927C18.5717 30.773 18.9062 33.0599 19.5753 37.6338L20.2097 41.9712C20.7344 45.558 20.9967 47.3514 22.3425 48.4254C23.6883 49.4994 25.6732 49.4994 29.643 49.4994H38.357C42.3268 49.4994 44.3117 49.4994 45.6575 48.4254C47.0033 47.3514 47.2656 45.558 47.7903 41.9712L48.4247 37.6338C49.0938 33.06 49.4283 30.773 48.0065 29.2927C46.5848 27.8125 44.0536 27.8125 38.9914 27.8125ZM37.8718 40.1908C38.7094 39.6715 38.7094 38.3273 37.8718 37.8081L32.8145 34.6729C32.0004 34.1682 31 34.8251 31 35.8642V42.1346C31 43.1738 32.0004 43.8306 32.8145 43.326L37.8718 40.1908Z",
    fill: "#DA4505"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M28.7629 19.5H39.233C39.5817 19.4999 39.8491 19.4999 40.0828 19.5227C41.7445 19.6853 43.1047 20.6844 43.6814 22.0302H24.3145C24.8912 20.6844 26.2514 19.6853 27.9131 19.5227C28.1468 19.4999 28.4142 19.4999 28.7629 19.5Z",
    fill: "#DA4505"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M25.4638 23.5859C23.3779 23.5859 21.6675 24.8456 21.0967 26.5166C21.0848 26.5515 21.0734 26.5865 21.0625 26.6217C21.6597 26.4408 22.2813 26.3227 22.9105 26.242C24.531 26.0342 26.579 26.0343 28.9581 26.0345H39.2962C41.6753 26.0343 43.7233 26.0342 45.3439 26.242C45.9731 26.3227 46.5946 26.4408 47.1918 26.6217C47.1809 26.5865 47.1695 26.5515 47.1576 26.5166C46.5868 24.8456 44.8764 23.5859 42.7905 23.5859H25.4638Z",
    fill: "#DA4505"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalVideosIcon);
export default __webpack_public_path__ + "static/media/Total_videos_icon.b6ac1f761934443e8582f9d663e66ca2.svg";
export { ForwardRef as ReactComponent };